module.exports = __webpack_public_path__ + "img/logotN 1.9b768808.png";